import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { PageLayout, MessagesList, MessageThread } from 'pages'

export const MessageRouter = () => {
  return (
    <Routes>
      <Route path="/*" element={<PageLayout showBackButton={true} />}>
        <Route path=":username" element={<MessageThread />} />
        <Route index element={<MessagesList />} />
      </Route>
    </Routes>
  )
}
